export const environment = {
  production: true,
  cordova: false,
  api: 'api/',
  chatApi: 'https://bot.skillconomy.com/api'
};
